import { ApiInventoryLevel } from '@vend/types'
import { fetchApi } from '@vend/utilities'

interface InventoryOptions {
  include_variants?: boolean
  location_ids?: string[]
}

/**
 * Get inventory information for the product identified by the given product ID.
 *
 * @param  productId
 *         The ID of the product to get inventory levels for
 *
 * @param  options
 *
 *         @param options.include_variants
 *         Whether to fetch inventory information for all variants of the given parent product
 *
 *         @param options.location_ids
 *         The IDs of outlets to fetch inventory information for (if omitted will be all outlets)
 *
 * @return A promise resolved with the array of inventory information for the
 *         given product
 */
export const getInventory = async (
  productIds: string[],
  options?: InventoryOptions
): Promise<ApiInventoryLevel[]> => {
  const optionsObject = {
    ...options,
    include_composites: true,
    product_ids: productIds,
    size: 1000,
  }
  const optionsString = JSON.stringify(optionsObject)

  const response = await fetchApi(
    `/api/2.0/inventory_levels?options=${optionsString}`,
    {
      method: 'GET',
    }
  )

  if (!response.ok) {
    throw new Error('Failed to get inventory levels')
  }

  const json = await response.json()

  return json.data
}
